module.exports = __webpack_public_path__ + "static/media/Capture.98f30d0b.JPG";